// components/Sidebar.jsx
import React from "react";
import { Card, List, Tag, Typography, Divider } from "antd";
import { TagsOutlined, FireOutlined } from "@ant-design/icons";

const { Title } = Typography;

const Sidebar = ({ popularTags, popularPosts }) => {
  return (
    <div>
      {/* 热门标签 */}
      <Card
        title={
          <Title level={5}>
            <TagsOutlined /> 热门标签
          </Title>
        }
        size="small"
      >
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {popularTags.map((tag, index) => (
            <Tag color="processing" key={tag.name}>
              {tag.name} ({tag.count})
            </Tag>
          ))}
        </div>
      </Card>

      <Divider />

      {/* 热门文章 */}
      <Card
        title={
          <Title level={5}>
            <FireOutlined /> 热门文章
          </Title>
        }
        size="small"
      >
        <List
          dataSource={popularPosts}
          renderItem={(post) => (
            <List.Item>
              <List.Item.Meta
                title={<Typography.Link ellipsis>{post.title}</Typography.Link>}
                description={`${post.views} 阅读`}
              />
            </List.Item>
          )}
        />
      </Card>
    </div>
  );
};

export default Sidebar;
